/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type TierLimits = {
  /**
   * Add-on items bullets of the tier (optional)
   */
  addOnBullets?: Array<string> | undefined;
  /**
   * The base price for the tier
   */
  basePrice: number;
  /**
   * Key feature bullets of the tier
   */
  featureBullets: Array<string>;
  /**
   * Included items bullets of the tier
   */
  includedBullets: Array<string>;
  /**
   * The number of credits included in the tier for playground and other dashboard activities
   */
  includedCredits: number;
  /**
   * The number of servers included in the tier
   */
  includedServers: number;
  /**
   * The number of tool calls included in the tier
   */
  includedToolCalls: number;
  /**
   * Exact USD list price per GiB of MCP gateway egress (optional)
   */
  mcpEgressPricePerGibUsd?: string | undefined;
  /**
   * The price per additional server
   */
  pricePerAdditionalServer: number;
  /**
   * The price per additional tool call
   */
  pricePerAdditionalToolCall: number;
  /**
   * Exact USD list price per million tokens scanned for risk (optional)
   */
  riskScanPricePerMillionUsd?: string | undefined;
  /**
   * Exact USD list price per million tokens under management (optional)
   */
  tumPricePerMillionUsd?: string | undefined;
};

/** @internal */
export const TierLimits$inboundSchema: z.ZodMiniType<TierLimits, unknown> = z
  .pipe(
    z.object({
      add_on_bullets: z.optional(z.array(z.string())),
      base_price: z.number(),
      feature_bullets: z.array(z.string()),
      included_bullets: z.array(z.string()),
      included_credits: z.int(),
      included_servers: z.int(),
      included_tool_calls: z.int(),
      mcp_egress_price_per_gib_usd: z.optional(z.string()),
      price_per_additional_server: z.number(),
      price_per_additional_tool_call: z.number(),
      risk_scan_price_per_million_usd: z.optional(z.string()),
      tum_price_per_million_usd: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        "add_on_bullets": "addOnBullets",
        "base_price": "basePrice",
        "feature_bullets": "featureBullets",
        "included_bullets": "includedBullets",
        "included_credits": "includedCredits",
        "included_servers": "includedServers",
        "included_tool_calls": "includedToolCalls",
        "mcp_egress_price_per_gib_usd": "mcpEgressPricePerGibUsd",
        "price_per_additional_server": "pricePerAdditionalServer",
        "price_per_additional_tool_call": "pricePerAdditionalToolCall",
        "risk_scan_price_per_million_usd": "riskScanPricePerMillionUsd",
        "tum_price_per_million_usd": "tumPricePerMillionUsd",
      });
    }),
  );

export function tierLimitsFromJSON(
  jsonString: string,
): SafeParseResult<TierLimits, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TierLimits$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TierLimits' from JSON`,
  );
}
